import { render, staticRenderFns } from "./AccountDetailModel.vue?vue&type=template&id=392f49b7&scoped=true"
import script from "./AccountDetailModel.vue?vue&type=script&lang=js"
export * from "./AccountDetailModel.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailModel.vue?vue&type=style&index=0&id=392f49b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f49b7",
  null
  
)

export default component.exports